
<template>
  <!--门禁设备-->
  <div class="smart-door" ref="smartDoor">
    <section class="dev-info">
      <div class="dev-num">
        <div>
          <div>
            <p>设备总数</p>
            <span>{{devStatist.active}}</span>
          </div>
        </div>
        <div>
          <div>
            <p>当前在线</p>
            <span>{{devStatist.online}}</span>
          </div>
        </div>
      </div>
      <a-button @click="DeviceStatus('update')" type="primary" :loading="refreshLoading.loading">刷新</a-button>
    </section>

    <x-tabula
      v-if="isShow"
      :style="{backgroundColor: '#fff', padding: '24px'}"
      ref="table"
      :dataSource="dataSource"
      rowKey="deviceId"
      @handleSelectChange="handleSelectChange"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="true"
      @resetSearch = "resetSearch"
  >
      <template slot="opt_online" slot-scope="{row}">
        <span>{{row.online === '1' ? '在线' : '离线'}}</span>
      </template>
  </x-tabula>

    <!--选择重启类型的弹窗-->
    <a-modal
      title="请选择重启类型"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="form">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="重启类型">
          <a-select
            v-decorator="['type', { rules: [{ required: true, message: '请选择重启类型' }] }]"
            placeholder="请选择重启类型">
            <a-select-option
              v-for="(item, index) of restartType"
              :key="index"
              :value="item.value"
              :disabled="item.disabled">{{item.label}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--获取日志的弹窗-->
    <a-modal
      title="获取日志"
      :visible="logModal"
      @ok="handleSubmit"
      @cancel="logModal=false"
      :confirmLoading="btnLoading.loading"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="logForm">
        <a-form-item label="日期范围" has-feedback v-bind="$store.state.long_itemLayout">
          <a-select
            @change="rangeChange"
            v-decorator="['content', { rules: [{required: true, message: '请选择日志范围' }]}]"
            allowClear
            showSearch
            placeholder="请选择日志范围">
            <a-select-option v-for="(el, order) of uploadLogType" :key="order" :value="el.value">{{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="pickerShow" label="选择日期" v-bind="$store.state.long_itemLayout">
          <a-date-picker
            v-show="isPicker"
            dropdownClassName="get-log-picker"
            @change="pickerChange"
            @ok="pickerConfirm"
            @openChange="pickerConfirm"
            v-decorator="['date', { rules: [{required: true, message: '请选择日期' }]}]"
            :showTime="true"
            :disabledDate="disabledDate"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"/>
          <a-input-search class="date-input" @search="pickerFocus" v-show="!isPicker" placeholder="" v-decorator="['dateStr']" allowClear>
            <a-button slot="enterButton">选择日期</a-button>
          </a-input-search>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--远程调试的弹窗-->
    <a-modal
      title="远程调试"
      :visible="debugVisible"
      @cancel="closeDebugModal"
      :width="700"
      :footer="null"
      v-bind="$store.state.modalConfig"
    >
      <a-form :form="debugForm">
        <a-form-item label="请求参数" v-bind="$store.state.modal_ItemLayout">
          <div :style="{display: 'flex', justifyConte: 'space-between'}">
            <a-input @change="reqParamChange" v-decorator="['content']" placeholder="请输入请求参数"/>
            <a-button :style="{marginLeft: '10px'}" v-if="!debugSuccess" @click="reqDebugging" :loading="btnLoading.loading" type="primary">提交参数</a-button>
            <a-button :style="{marginLeft: '10px'}" v-else @click="getDebugResult(debugTime)" :loading="btnLoading.loading" type="primary">获取结果</a-button>
          </div>
        </a-form-item>

        <a-form-item label="响应结果" v-bind="$store.state.modal_ItemLayout">
        <a-textarea v-decorator="['resContent']" rows="4" :placeholder="resTip"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--设备批量重启或升级结果的弹窗-->
    <a-modal
      :getContainer="() => $refs.smartDoor"
      :visible="batchOptVisible"
      @cancel="batchOptVisible = false"
      :width="450"
      :footer="null"
      v-bind="$store.state.modalConfig"
    >
      <p class="modal-title">
        <span class="txt">{{modalTitle}}</span>
<!--    <span class="scale">{{resultObj.success}}/{{resultObj.total}}</span>-->
      </p>
      <ul class="result-box">
        <li class="item" v-for="(item, index) of resultObj" :key="index">
          <div class="">
            <p class="code">{{item}}</p>
<!--        <p class="position">{{item.title}}</p>-->
          </div>
          <span :class="'success'">推送成功</span>
          <!--<template v-if="modalTitle === '升级结果'">-->
<!--            <span :class="['推送成功', '已是最新'].some(part => part === item.upgradeStatus) ?'success':'error'">{{item.upgradeStatus}}</span>-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            <span :class="['推送成功', '已是最新'].some(part => part === item.rebootStatus) ? 'success':'error'">{{item.rebootStatus}}</span>-->
<!--          </template>-->
        </li>
      </ul>
    </a-modal>

    <!--确定升级的弹窗-->
<!--    <a-modal-->
<!--      ref="upgradeModal"-->
<!--      title="升级"-->
<!--      :visible="upgradeVisible"-->
<!--      @cancel="upgradeVisible=false"-->
<!--      @ok="confirmUpgrade"-->
<!--      :confirmLoading="btnLoading.loading"-->
<!--      v-bind="$store.state.modalConfig"-->
<!--      :width="400"-->
<!--      :closable="false"-->
<!--    >-->
<!--      <p>{{updateObj.newVersion}}</p>-->
<!--    </a-modal>-->

    <!--添加设备的弹窗-->
    <a-modal
      title="添加设备"
      :footer="null"
      :visible="devicedVisible"
      @cancel="cancelDevicedVisible"
      @ok="isSubmitFun = true"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
    >
      <x-addEdit
        ref="addForm"
        @updateIsSubmit="isSubmitFun=$event"
        :itemLayout="$store.state.modal_ItemLayout"
        :isSubmit="isSubmitFun"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
      >
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { empty } from 'ant-design-vue-admin-x';

export default {
  mixins: [fetchSelect],
  name: 'smartDoor',
  data () {
    return {
      isShow: true,
      updateObj: {},
      upgradeVisible: false,
      batchReset: false,
      devicedVisible: false,
      isSubmitFun: false,
      resultObj: [],
      modalTitle: '',
      batchOptVisible: false,
      debugTime: '',
      debugSuccess: false,
      resTip: '响应结果',
      debugVisible: false,
      logModal: false,
      snCode: '',
      visible: false,
      btnLoading: { loading: false },
      refreshLoading: { loading: false },
      devStatist: {
        deviceCount: '',
        deviceOnline: ''
      },
      restartType: [
        { label: '系统', value: 'sys_reboot' },
        { label: 'apk', value: 'app_reboot' }
      ],
      pickerShow: false,
      isPicker: true,
      dateValues: [],
      uploadLogType: [
        { label: '仅今日', value: 'today' },
        { label: '按日期', value: 'date' },
        { label: '所有', value: 'all' }
      ],
      communityId: undefined,
      positionType: undefined,
      /** table 参数 */
      searchList: [
        { props: ['communityId'], placeholder: '小区名称', options: [], inputType: 'select', fetchOptions: this.getListOptions},
        { props: ['deviceName'], placeholder: '设备名称', options: [], inputType: 'input' },
        { props: ['deviceSncode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: ['productId'], placeholder: '产品型号', options: [], inputType: 'select' },
        { props: ['online'], placeholder: '在线状态', options: [], inputType: 'select' },
        {
          props: ['areaId'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(5, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['createDate'], placeholder: ['添加时间', '添加时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '添加设备', icon: 'plus', handle: this.openDeviceModel, permi: ['community:device:active'] },
        { text: '生成云对讲账户', icon: 'phone', disabled: true, handle: this.createTalkAccount, permi: ['community:device:account'] },
        { text: '删除', icon: 'close', disabled: true, handle: '', permi: ['community:device:remove'] },
        { text: '初始化设备', icon: 'tool', disabled: true, handle: this.initDevice, permi: ['community:device:init'] },
        { text: '同步数据', icon: 'sync', disabled: true, handle: this.resetDevice, permi: ['community:device:syncdata'] },
        { text: '同步人脸', icon: 'smile', disabled: true, handle: this.syncFace, permi: ['community:device:syncface'] },
        { text: '设备重启', icon: 'poweroff', disabled: true, handle: (ids, rows) => this.openModal(ids, rows, true), permi: ['community:device:reboot'] },
        { text: '设备升级', icon: 'cloud-upload', disabled: true, handle: (ids, rows) => this.openUpDateModal(ids, rows, true), permi: ['community:device:promotion'] },
        { text: '更新信息', icon: 'cloud-upload', disabled: true, handle: (ids, rows) => this.handleUpdateInfo(ids, rows), permi: ['community:device:update'] }
      ],
      rowOptList: [
        {
          text: '详情',
          handle: (row) => this.toDetail(row.deviceId),
          permi: ['community:device:detail']
        },
        {
          text: '修改',
          handle: (row) => this.$refs.table.toEdit(row),
          rowOptDisHandle: this.handleProductA1,
          permi: ['community:device:edit']
        },
        {
          text: '初始化设备',
          handle: (row) => this.initDevice(row.deviceSncode),
          rowOptDisHandle: this.handleProductA1,
          permi: ['community:device:init']
        },
        [
          {
            text: '重启',
            handle: (row) => this.openModal(row, null, false),
            rowOptDisHandle: this.handleProductA1,
            permi: ['community:device:reboot']
          },
          {
            text: '升级',
            handle: (row) => this.openUpDateModal(row, null, false),
            rowOptDisHandle: (row) => row.canUpgrade === 0 || this.handleProductA1(row),
            permi: ['community:device:update']
          },
          {
            text: '删除',
            handle: (row) => this.$refs.table.showDeleteConfirm(row),
            key: 'delete',
            permi: ['community:device:remove']
          },
          {
            text: '获取日志',
            handle: (row) => this.openLogModal(row),
            rowOptDisHandle: this.handleProductA1,
            permi: ['community:device:uploadlog']
          },
          {
            text: '开门日志',
            handle: row => this.toOpenLog(row),
            rowOptDisHandle: this.handleProductA1,
            permi: ['community:device:openlog']
          },
          {
            text: '同步日志',
            handle: row => this.toSyncLog(row),
            rowOptDisHandle: this.handleProductA1,
            permi: ['community:device:tasks']
          }
        ]
      ],
      columns: [
        { title: '位置', dataIndex: 'address', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'deviceName', align: 'left', width: '' },
        { title: '设备编码', dataIndex: 'deviceSncode', align: 'left', width: '' },
        { title: '产品型号', dataIndex: 'productType', align: 'left', width: '' },
        { title: '当前版本', dataIndex: 'version', align: 'left', width: '' },
        { title: '状态', dataIndex: 'online', align: 'left', width: '', scopedSlots: {customRender: 'online'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        communityId: undefined,
        deviceName: undefined,
        deviceSncode: undefined,
        productId: undefined,
        online: undefined,
        areaId: undefined,
        propertyId: undefined,
        createDate: undefined
      },
      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'editSmartDoor',
        title: '编辑门禁'
      },
      deleteParam: {
        url: '/device/',
        // param: {pk_key: 'deviceId', pk_val: ''},
        title: '门禁设备',
        key: 'deviceName'
      },
      formKey: {
        deviceSncode: undefined,
        deviceName: undefined,
        communityId: undefined,
        positionType: undefined,
        positionId: undefined
      },
      formList: [
        {
          label: '设备编码',
          inputType: 'input',
          options: [],
          placeholder: '请输入设备编码',
          props: ['deviceSncode', {
            rules: [{required: true, message: '请输入设备编码'}]
          }]
        },
        {
          label: '设备名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入设备名',
          props: ['deviceName', {
            rules: [{required: true, message: '请输入设备名'}]
          }]
        },
        {
          label: '选择小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择小区',
          handle: (e) => {
            this.$refs.addForm.form.resetFields(['positionType', 'positionId']);
            this.formList[4].options = [];

            this.communityId = e;
            this.getBelongPosition();
          },
          fetchOptions: this.getOptions,
          props: ['communityId', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        },
        {
          label: '位置分类',
          inputType: 'select',
          options: [],
          handle: (e) => {
            this.$refs.addForm.form.resetFields(['positionId']);
            this.formList[4].options = [];

            this.positionType = e;
            this.getBelongPosition();
          },
          placeholder: '请选择位置分类',
          props: ['positionType', {
            rules: [{required: true, message: '请选择位置分类'}]
          }]
        },
        {
          label: '所属位置',
          inputType: 'select',
          options: [],
          placeholder: '请选择所属位置',
          props: ['positionId', {
            rules: [{required: true, message: '请选择所属位置'}]
          }]
        }
      ],
      addParam: {
        url: '/device/active',
        reqHandle: '',
        resHandle: this.addResHandle
      }
    };
  },
  activated () {
    this.$nextTick(() => {
      if (!this.searchParams.deviceSncode) {
        empty.$emit('setSearchValue', { deviceSncode: undefined });
      }
    });
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.logForm = this.$form.createForm(this);
    this.debugForm = this.$form.createForm(this);
  },
  created () {
    this.DeviceStatus();
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'formList', 2);
    },
    getListOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    /** 处理产品型号 A1 */
    handleProductA1 (row) {
      return row.productType === 'A1';
    },
    /**
     * table change 事件
     * 多选操作产品型号为A1，除了删除其他操作都禁用
     * */
    handleSelectChange (rows) {
      let arr = rows.filter(this.handleProductA1);
      if (arr && arr.length) {
        this.tableOptList.forEach(item => {
          if (item.text !== '添加设备') {
            item.text !== '删除' ? item.disabled = true : item.disabled = false;
          }
        });
      }
    },
    disabledDate (date) {
      const val = date.valueOf();
      const before = Date.now() - 1000 * 60 * 60 * 24 * 15;
      return val < before || val > Date.now();
    },
    pickerFocus () {
      this.dateValues = [];
      this.isPicker = true;
      this.logForm.setFieldsValue({ date: undefined });
    },
    pickerConfirm (status) {
      if (!status) {
        this.isPicker = false;

        this.$nextTick(() => {
          const input = document.getElementsByClassName('date-input')[0];
          input.getElementsByClassName('ant-input')[0].setAttribute('readonly', 'true');
        });

        let dateStr = this.dateValues.join(', ');
        this.logForm.setFieldsValue({ dateStr: dateStr });
      }
    },
    /** 选择日期事件 */
    pickerChange (event) {
      let noInclude = this.dateValues.every(item => item !== event);
      noInclude && this.dateValues.push(event);
    },
    /** 日期范围选择 */
    rangeChange (event) {
      event === 'date' ? this.pickerShow = true : this.pickerShow = false;
    },
    /** 处理批量更新信息 */
    handleUpdateInfo (ids, rows) {
      let params = this.handleDevSncode(rows);
      this.$confirm({
        title: `确定要更新这 ${rows.length} 台设备信息？`,
        centered: true,
        onOk: () => {
          this.$post({
            url: '/device/updateCommunityInfo',
            params: { deviceSncodes: params }
          }).then(({ data }) => {
            this.$message.success('更新成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    /** 跳转至开门日志 */
    toOpenLog (row) {
      this.$router.push({
        name: 'openLog',
        query: {
          id: row.deviceSncode
        }
      });
    },
    /** 跳转至同步日志 */
    toSyncLog (row) {
      this.$router.push({
        name: 'syncOptLog',
        query: {
          id: row.deviceSncode
        }
      });
    },
    /** 同步人脸 */
    syncFace (ids, rows) {
      this.$confirm({
        title: `确定这 ${rows.length} 台设备同步人脸？`,
        centered: true,
        onOk: () => {
          let id = this.handleDevSncode(rows);
          this.$post({
            url: '/device/syncFaceData',
            params: { deviceSncodes: id }
          }).then(({data}) => {
            this.$message.success('同步成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    /** 判断是否禁用远程调试选项 */
    disabledDebug (row) {
      let productType = row.productType;
      if (!(productType && productType[0] === 'B')) {
        return true;
      }
    },
    /** 请求参数 change事件 */
    reqParamChange (e) {
      this.debugSuccess = false;
      this.debugTime = '';
    },
    /** 关闭调试窗口 */
    closeDebugModal () {
      this.debugVisible = false;
      this.debugSuccess = false;
      this.debugTime = '';
    },
    /** 打开调试弹窗 */
    openDebugModal (row) {
      if (row.productType[0] === 'B') {
        this.snCode = row.deviceSncode;
        this.debugVisible = true;
      }
    },
    /** 远程调试 */
    reqDebugging () {
      this.debugForm.resetFields(['resContent']);
      this.debugForm.validateFields((err, values) => {
        if (err) { return; }
        this.$post({
          url: '/smart_door_eq/debugging',
          params: {
            deviceSncode: this.snCode,
            ...values
          },
          btnLoading: this.btnLoading
        }).then(({data}) => {
          this.debugTime = data.debug_time;
          this.getDebugResult(data.debug_time);
          this.debugSuccess = true;
        }).catch(() => {
        });
      });
    },
    /** 获取debug结果 */
    getDebugResult () {
      this.resTip = '等待响应...';
      this.$get({
        url: '/smart_door_eq/debug_result',
        params: {
          deviceSncode: this.snCode,
          debug_time: this.debugTime
        },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        setTimeout(() => {
          this.resTip = '响应结果';
          this.debugSuccess = false;
          this.debugForm.setFieldsValue({ resContent: data.content });
        }, 300);
      }).catch(() => {
        this.resTip = '响应结果';
      });
    },
    /* 初始化设备 */
    initDevice (id, rows) {
      this.$confirm({
        title: '确定要初始化设备？',
        centered: true,
        onOk: () => {
          if (rows && Array.isArray(rows)) {
            id = this.handleDevSncode(rows);
          }
          this.$post({
            url: '/device/init',
            params: { deviceSncodes: id }
          }).then((res) => {
            this.$message.success('初始化成功！');
          });
        }
      });
    },
    handleDevSncode (rows) {
      let snCodeArr = rows.map(item => item.deviceSncode);
      return snCodeArr.join(',');
    },
    /* 同步数据 */
    resetDevice (selectedId, rows) {
      let snCodeArr = this.handleDevSncode(rows);
      this.$confirm({
        title: `你确定这 ${rows.length} 台设备同步数据？`,
        centered: true,
        onOk: () => {
          this.$post({
            url: '/device/syncData',
            params: { deviceSncodes: snCodeArr }
          }).then((res) => {
            this.$message.success('同步数据成功');
          });
        }
      });
    },
    /* 获取下拉 */
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.regionSelect(5);
      this.propertySelect(6);
      this.$get({
        url: '/device/product/treeselect'
      }).then(({data}) => {
        this.searchList[3].options = data;
      });
      let paramArr = [{index: 4, scope: 'searchList', query: 'comu_device_online_type'}];
      this.dictionarySelect(paramArr);
    },
    /* 获取设备状态 */
    DeviceStatus (update) {
      let paramObj = { url: '/device/statist' };
      update && (paramObj.btnLoading = this.refreshLoading);
      this.$get(paramObj).then(({data}) => {
        this.devStatist = data;
        this.getList();
        update && this.$message.success('设备状态同步成功！');
      }).catch(() => {
        this.getList();
      });
    },
    getList () {
      this.listApi.url = '/device/list';
      this.$refs.table.getTableList();
    },
    /* 生成云对讲账户 */
    createTalkAccount (id) {
      this.$confirm({
        title: `确定要生成 ${id.length} 台设备的云对讲账户？`,
        centered: true,
        onOk: () => {
          id = id.join(',');
          this.$post({
            url: '/device/createAccount',
            params: { deviceIds: id }
          }).then((res) => {
            this.$message.success(`${res.msg}`);
          });
        }
      });
    },
    /* 进入详情页面 */
    toDetail (id) {
      this.$router.push({
        name: 'smartDoorDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /* 打开重启设备弹窗 */
    openModal (ids, rows, batch) {
      batch ? (this.batchReset = true) : (this.batchReset = false);
      let productType;
      if (rows && Array.isArray(rows)) {
        if (!this.validaType(rows)) {
          this.$message.error('请选择产品型号一致的设备');
          return;
        }
        this.snCode = this.handleDevSncode(rows);
        productType = rows[0].productType;
      } else {
        this.snCode = ids.deviceSncode;
        productType = ids.productType;
      }
      let apk = this.restartType[1];
      productType && productType.toLowerCase().includes('b') ? apk.disabled = true : apk.disabled = false;
      this.visible = true;
    },
    validaType (list) {
      let arr = [];
      for (let item of list) {
        let type = item.productType && item.productType;
        if (!arr.every(el => el === type)) {
          return false;
        }
        arr.push(type);
      }
      return true;
    },
    /* 设备重启确定弹窗 */
    confirm () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.submitRestart(values);
      });
    },
    /** 提交重启 */
    submitRestart (values) {
      this.$post({
        url: '/device/reboot',
        params: { deviceSncodes: this.snCode, ...values },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        this.visible = false;
        this.snCode = '';
        if (this.batchReset === true) {
          this.resultObj = data;
          this.modalTitle = '重启结果';
          this.batchOptVisible = true;
        } else {
          this.$message.success('重启成功！');
        }
      });
    },
    /** 打开升级弹窗 */
    openUpDateModal (row, rows, batchOpt) {
      if (batchOpt) {
        if (!this.validaType(rows)) {
          this.$message.error('请选择产品型号一致的设备');
          return;
        }
      }

      if ((row && row.productType === 'B1') || (rows && rows.every(item => item.productType === 'B1'))) {
        if (batchOpt) {
          this.snCode = this.handleDevSncode(rows);
        } else {
          this.snCode = row.deviceSncode;
        }
        let msg = batchOpt ? `已选 ${rows.length} 台设备，确定要升级？` : '确定要升级？';
        this.$confirm({
          title: msg,
          centered: true,
          onOk: () => { this.batchUpDate(batchOpt); }
        });
      } else {
        let canGrade, gradeMsg;
        if (batchOpt) {
          this.snCode = this.handleDevSncode(rows);
          let gradeAble = rows.some(item => item.canUpgrade === 1);
          gradeAble ? canGrade = true : canGrade = false;
        } else {
          this.snCode = row.deviceSncode;
          row.canUpgrade === 1 ? canGrade = true : canGrade = false;
        }
        if (canGrade) {
          if (batchOpt) {
            gradeMsg = `已选 ${rows.length} 台设备，检测到最新版本 ${rows[0].newVersion}，确定升级？`;
          } else {
            gradeMsg = `检测到最新版本 ${row.newVersion}，确定升级？`;
          }
        } else {
          gradeMsg = '没有可升级的设备';
        }

        this[canGrade ? '$confirm' : '$error']({
          title: gradeMsg,
          okType: 'danger',
          centered: true,
          width: 440,
          onOk: () => {
            canGrade && this.batchUpDate(batchOpt);
          }
        });
      }
    },
    /** 批量升级 */
    batchUpDate (batchOpt) {
      this.$post({
        url: '/device/upgrade',
        params: { deviceSncodes: this.snCode },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        if (batchOpt) {
          this.resultObj = data;
          this.modalTitle = '升级结果';
          this.batchOptVisible = true;
        } else {
          this.$message.success('升级成功！');
        }

        this.$refs.table.getTableList();
      });
    },
    /** 确定升级弹窗 */
    confirmUpgrade () {
      if (this.updateObj.batchOpt) {
        this.batchUpDate();
      } else {
        this.update();
      }
    },
    /** 打开获取日志弹窗 */
    openLogModal (record) {
      this.snCode = record.deviceSncode;
      if (record.productType[0] === 'B') {
        this.handleSubmit('blackBox');
      } else {
        this.logModal = true;
      }
    },
    /** 获取日志 */
    handleSubmit (blackBox) {
      if (blackBox === 'blackBox') {
        this.fetchLog();
      } else {
        this.logForm.validateFields((err, values) => {
          if (err) { return; }
          this.fetchLog(values);
        });
      }
    },
    /** 获取日志 */
    fetchLog (values = {}) {
      if (values.content === 'date') {
        values.content = values.dateStr.split(', ').join(',');
      }

      this.$get({
        url: '/device/uploadLog',
        params: {
          deviceSncode: this.snCode,
          type: values.content
        },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        this.$message.success('获取日志成功');
        this.closeLogModal();
      });
    },
    closeLogModal () {
      this.isPicker = true;
      this.dateValues = [];
      this.pickerShow = false;
      this.logModal = false;
    },
    // 新增设备弹窗
    openDeviceModel () {
      // this.communitySelect(2, 'formList', 1);
      this.communitySelectByStep(1);
      let paramArr = [{ index: 3, scope: 'formList', query: 'comu_position_type' }];
      this.dictionarySelect(paramArr);

      this.devicedVisible = true;
    },
    /** 获取位置下拉（根据小区） */
    getBelongPosition () {
      if (this.communityId && this.positionType) {
        this.$get({
          url: '/position/treeselect',
          params: {
            communityId: this.communityId,
            categoryId: this.positionType
          }
        }).then(({data}) => {
          this.formList[4].options = data;
        });
      }
    },
    /** 关闭添加设备弹窗 */
    cancelDevicedVisible () {
      this.devicedVisible = false;
      this.communityId = this.positionType = this.search = undefined;
    },
    addResHandle (res) {
      this.$message.success(res.msg);
      this.$refs.table.getTableList();
      this.devicedVisible = false;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>

<style lang="scss">
  @import "../../../style/variable";
  .smart-door {
    .ant-modal-body {
      padding: 0;
    }

    .modal-title {
      padding-left: 24px;
      line-height: 50px;
      border-bottom: 1px solid $gray_1;
      .txt {
        margin-right: 60px;
        font-size: 16px;
        font-weight: 700;
      }
      .scale {
        font-size: 15px;
        color: $red_1;
      }
    }
    .result-box {
      padding: 0 24px;
      height: 300px;
      overflow-y: auto;
      .item {
        padding-right: 24px;
        height: 66px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        .code {
          color: #999;
          line-height: 13px;
        }
        .position {
          margin-top: 14px;
          font-weight: 700;
          color: #666;
          line-height: 13px;
        }
        .success {
          color: $green_1;
        }
        .error {
          color: $red_1;
        }
      }
      .item+.item {
        border-top: 1px solid $gray_1;
      }
    }
  }

  /* 门禁设备 */
  .dev-info {
    margin-bottom: 20px;
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    background-color: #fff;
    .dev-num {
      display: flex;
      >div:first-child {
        border-right: 1px solid #999;
      }
      >div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 150px;
        >div {
          text-align: left;
          span {
            font-size: 20px;
            font-weight: 500;
          }
        }
      }
    }
  }
</style>
